<tax-modal-header>modal.token.title</tax-modal-header>

<tax-modal-content>
  <div class="token-text">
    <p translate data-qa="token-description-text-1">modal.token.text</p>
    <p translate data-qa="token-description-text-2">modal.token.description</p>
  </div>
  <div data-qa-input="token">
    <label for="tokens" translate data-qa="label-text">modal.token</label>
    <div class="token-bottom">
      <input
        [(ngModel)]="token"
        maxlength="8"
        class="token-input"
        id="tokens"
        readonly="readonly"
        data-qa="input"
      />
      <button data-qa-button="get-token" (click)="getToken()" class="button_blue" translate>
        button.get
      </button>
    </div>
  </div>
</tax-modal-content>
